import { combineReducers } from 'redux';
import { reducer as marketAvailabilityReducer } from './marketAvailability';

export { loadZipcodesAvailability, loadZipcodeDetails, resetMarketAvailability } from './marketAvailability';

export const reducer = combineReducers({
  marketAvailability: marketAvailabilityReducer,
});
